import React from 'react'
import not from '../../assets/404.svg'
export default function Notfound() {
  return (
    <div>
      <div className="row container ">
        <div className="col-lg-8 flex-col p-3 mx-auto">
          <h2 className='text-3xl text-red-500 font-bold text-center'>Page non trouvee</h2>
          <img src={not} alt="" className="w-44 h-44 mx-auto" srcset="" />
        </div>
      </div>
    </div>
  )
}
